/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRiskPolicyBypassRequestRequestBody,
  CreateRiskPolicyBypassRequestRequestBody$Outbound,
  CreateRiskPolicyBypassRequestRequestBody$outboundSchema,
} from "../components/createriskpolicybypassrequestrequestbody.js";

export type CreateRiskPolicyBypassRequestSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type CreateRiskPolicyBypassRequestRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  createRiskPolicyBypassRequestRequestBody:
    CreateRiskPolicyBypassRequestRequestBody;
};

/** @internal */
export type CreateRiskPolicyBypassRequestSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const CreateRiskPolicyBypassRequestSecurity$outboundSchema:
  z.ZodMiniType<
    CreateRiskPolicyBypassRequestSecurity$Outbound,
    CreateRiskPolicyBypassRequestSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function createRiskPolicyBypassRequestSecurityToJSON(
  createRiskPolicyBypassRequestSecurity: CreateRiskPolicyBypassRequestSecurity,
): string {
  return JSON.stringify(
    CreateRiskPolicyBypassRequestSecurity$outboundSchema.parse(
      createRiskPolicyBypassRequestSecurity,
    ),
  );
}

/** @internal */
export type CreateRiskPolicyBypassRequestRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  CreateRiskPolicyBypassRequestRequestBody:
    CreateRiskPolicyBypassRequestRequestBody$Outbound;
};

/** @internal */
export const CreateRiskPolicyBypassRequestRequest$outboundSchema: z.ZodMiniType<
  CreateRiskPolicyBypassRequestRequest$Outbound,
  CreateRiskPolicyBypassRequestRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    createRiskPolicyBypassRequestRequestBody:
      CreateRiskPolicyBypassRequestRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      createRiskPolicyBypassRequestRequestBody:
        "CreateRiskPolicyBypassRequestRequestBody",
    });
  }),
);

export function createRiskPolicyBypassRequestRequestToJSON(
  createRiskPolicyBypassRequestRequest: CreateRiskPolicyBypassRequestRequest,
): string {
  return JSON.stringify(
    CreateRiskPolicyBypassRequestRequest$outboundSchema.parse(
      createRiskPolicyBypassRequestRequest,
    ),
  );
}
